import { Link } from "react-router-dom";
import { ChevronLeft } from "lucide-react";

export default function BackLink({ to }: { to: string }) {
  return (
    <div className="bg-gray-100 border-b px-2 py-1">
      <Link to={to} className="flex items-center space-x-1">
        <ChevronLeft size={15} />
        <span className="">Back</span>
      </Link>
    </div>
  );
}
